<template>
    <div class="ws-unit">
        <div class="ws-unit-header ">
            <div class="ws-unit-title">
                需求
            </div>
            <div class="ws-unit-toolbar">
                <el-button
                    type="primary"
                    size="small"
                    round
                    icon="el-icon-plus"
                    @click="create"
                    v-if="company"
                >添加</el-button>
            </div>
        </div>
        <div class="ws-unit-body">
            <div class="table-container">
        <el-table
            :data="demands"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    {{props.row.brief||'-暂无简介-'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="domain.name"
                label="分类"
                show-overflow-tooltip
                width="120"
            >
            </el-table-column>
            <el-table-column
                prop="name"
                label="名称"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                prop="cycle"
                label="研发周期"
                max-width="180"
            ></el-table-column>
            <el-table-column
                prop="budget"
                show-overflow-tooltip
                label="预算"
                max-width="180"
            ></el-table-column>
            <el-table-column
                prop="contact"
                label="联系人"
                show-overflow-tooltip
            >
            <template slot-scope="props">
                <span v-if="props.row.contact">
                    {{props.row.contact}}({{props.row.phone||'-无电话号码-'}})
                </span>
                <span v-else>
                    {{props.row.company.contact}}({{props.row.company.phone||'-无电话号码-'}})
                </span>
            </template>
            </el-table-column>
            <el-table-column
                prop="top"
                label="置顶"
                width="90"
                :formatter="boolFormatter"
            ></el-table-column>
            <el-table-column
                prop="created_at"
                width="160"
                label="创建时间"
                align="center"
                :formatter="unixFormatter"
            ></el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
            >
                <template slot-scope="scope">
                    <el-button
                        @click="edit(scope.row)"
                        type="text"
                        size="mini"
                    >编辑</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <ox-safe-button
                        @confirm="remove(scope.row)"
                        type="text"
                        size="small"
                    >删除</ox-safe-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
        </div>
        <demand-form
            @success="onSaveSuccess"
            :company="company"
            ref="dialog"
        />
    </div>
</template>

<script>
import { fmtMixin } from "@/ox/Mixins";
import OxSafeButton from "@/ox/components/OxSafeButton";
import DemandForm from "@/pages/demand/Form.vue";

export default {
    name: "Technqiue",
    props: {
        company: {
            type: Object,
            value: function() {
                return null;
            }
        }
    },
    mixins: [fmtMixin],
    components: {
        OxSafeButton,
        DemandForm
    },
    watch: {
        company: function(newVal){
            if(newVal){
                this.loadData(1);
            }else{
                this.page = 1;
                this.demands = [];
            }
        }
    },
    data: function() {
        return {
            page: 1,
            isLoading: false,
            demands: []
        };
    },
    methods: {
        loadData() {
            this.isLoading = true;
            const query = new window.BaaS.Query();
            query.compare("company", "=", this.company.id);
            this.$ox
                .service("demand")
                .find(query, {
                    pageSize: 50,
                    withCount: true,
                    expand: ["domain", "company"],
                    orderBy: ["top", "-updated_at"]
                })
                .then(res => {
                    this.isLoading = false;
                    this.demands = res.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        create() {
            this.$refs.dialog.show();
        },
        onSearch() {
            this.loadData(1);
        },
        onSaveSuccess() {
            this.loadData();
        },
        edit(row) {
            this.$refs.dialog.show(row);
        },
        remove(row) {
            this.$ox
                .service("demand")
                .delete(row.id)
                .then(() => {
                    this.demands = this.demands.filter(
                        demand => demand.id !== row.id
                    );
                    this.$notify.success({
                        title: "操作成功",
                        message: `需求"${row.name}"已删除`
                    });
                });
        }
    }
};
</script>

<style scoped>
.name {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.name i {
    font-size: 16px;
    color: #409eff;
    display: inline-block;
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: 5px;
    cursor: pointer;
    vertical-align: middle;
    line-height: 21px;
}
</style>